import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CrudService } from 'src/app/@amiga-pyme/services/crud.service';

const baseRoute = '/dashboard/branch-sales-month';

@Injectable({
  providedIn: 'root'
})
export class TestMonthtlyBusinessService extends CrudService {
  constructor(http: HttpClient) {
    super(http, baseRoute);
  }

  getBackendResponseProcessed(statistics_data: any): any {
    const { data, months } = statistics_data;

    const datasets = Object.entries(data).map(
      ([local, salesByMonth]: [string, any[]], index) => {
        return {
          name: local,
          data: salesByMonth.reverse()
        };
      }
    );

    return {
      categories: months.reverse(),
      datasets: datasets
    };
  }
}
